import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

export interface OpenTabRequest {
  url: string;
  label?: string;
}

export interface TabUpdate {
  path?: string;
  label?: string;
}

@Injectable({ providedIn: 'root' })
export class TabService {
  readonly #openTab$ = new Subject<OpenTabRequest>();
  readonly openTab$ = this.#openTab$.asObservable();

  readonly #updateTab$ = new Subject<TabUpdate>();
  readonly updateTab$ = this.#updateTab$.asObservable();

  openInNewTab(url: string, label?: string): void {
    this.#openTab$.next({ label, url });
  }

  /** Update the active tab's stored path without triggering navigation. */
  updateCurrentTabPath(url: string): void {
    this.#updateTab$.next({ path: url });
  }

  /** Update the active tab's label (already-translated display text). */
  updateCurrentTabLabel(label: string): void {
    this.#updateTab$.next({ label });
  }
}
